import { SporsmalType, TallValidationType } from '../../types/generated-types';
import { CurrentSporsmal } from '../reducer/current-steg';
import { Tallsporsmal } from '../reducer/sporsmalsflyt-types';

export interface CurrentTallsporsmal {
    type: SporsmalType.Tall;
    sporsmal: Tallsporsmal;
    tall?: number;
    maleenhet: string;
    tallvalidering: TallValidationType;
}

export interface BesvartTallsporsmal {
    type: SporsmalType.Tall;
    sporsmal: Tallsporsmal;
    tall: number;
    maleenhet: string;
    tallvalidering: TallValidationType;
}

export const isTallSporsmal = (currentSporsmal: CurrentSporsmal): currentSporsmal is CurrentTallsporsmal =>
    currentSporsmal.type === SporsmalType.Tall;

export const getTallNumber = (currentSporsmal: CurrentTallsporsmal): number => Number(currentSporsmal.tall.toFixed(1));

export const updateTall = (currentSporsmal: CurrentTallsporsmal, updatedTall: number): CurrentTallsporsmal => ({
    ...currentSporsmal,
    tall: updatedTall,
});

export const getBelopNumber = (currentSporsmal: CurrentTallsporsmal): number => currentSporsmal.tall || 0;
